
import { ListAlocacoes, ListRoles, ListPermissions } from '../../Pages';
/* 🧩 COMPONENTS */
import { Button, Breadcrumb } from "../../Components";

import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from 'framer-motion';
import { useSearchParams } from 'react-router-dom';
/* 🎨 STYLES */
import { Container, ContainerButtons } from "./styles";

const validCruds = [ 'allocations', 'roles', 'permissions' ];

function AdminCruds() {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();

    const crudParam = searchParams.get('crud');
    const currentList = crudParam && validCruds.includes(crudParam) ? crudParam : 'allocations';

    const handleChange = (value) => {
        setSearchParams({ crud: value });
    };

    const navigationFlow =  [
        { text: 'administrative', page: '/adm/alocacoes' },
        { text: 'employees', page: '/adm/funcionarios' },
        currentList === 'allocations'?
            { text: 'allocations', page: '/adm/alocacoes' } 
        : currentList === 'roles' ?
            { text: 'positions', page: '/adm/cargos' }
        :
            { text: 'permissions', page: '/adm/permissoes' }
    ]

    return (
        <Container>

            <Breadcrumb flow={navigationFlow}/>

            <ContainerButtons>
                <Button
                    id="allocations-list-btn"
                    type='button'
                    text={t("administrative.sub-items.allocations.sidebar-title")}
                    color={currentList === 'allocations'? 'greenSelected': 'green'}
                    onClick={() => handleChange('allocations')}
                />
                <Button
                    id="roles-list-btn"
                    type='button'
                    text={t("administrative.sub-items.positions.sidebar-title")}
                    color={currentList === 'roles'? 'greenSelected': 'green'}
                    onClick={() => handleChange('roles')}
                />
                <Button
                    id="permissions-list-btn"
                    type='button'
                    text={t("administrative.sub-items.permissions.sidebar-title")}
                    color={currentList === 'permissions'? 'greenSelected': 'green'}
                    onClick={() => handleChange('permissions')}
                />
            </ContainerButtons>

            <AnimatePresence mode="wait">
                <motion.div
                    key={currentList}
                    initial={{ opacity: 0, x: 40 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -40 }}
                    transition={{ duration: 0.3 }}
                >
                    {currentList === 'allocations' && <ListAlocacoes />}
                    {currentList === 'roles' && <ListRoles />}
                    {currentList === 'permissions' && <ListPermissions />}
                </motion.div>
            </AnimatePresence>
        </Container>
    );
}

export default AdminCruds;